export const environment = {
  production: false,

  /**
   * AppBridge Config: Used for custom actions and menu items where there is a new bowling alley tab.
   *  - url: The url of the bowling alley tab (used for menu items, overwritten in AppBridge.service.ts dynamically for custom actions)
   *  - title: Overwrites the title of the bowling alley tab for a custom action.
   *  - color: Overwrites the color of the bowling alley tab for a custom action.
   */
  appBridgeConfig: {
    url: 'https://bh-job-match-8ab81b71eadc.herokuapp.com/',
    title: 'Add Target',
    color: 'neutral',
    id: 'cubex-job-match',
    name: 'CubexJobMatchWnd',
    uuid: 'cubexJobMatch',
    windowName: 'CubexJobMatchWnd',
  },
  appBridgeConfigTarget: {
    url: 'https://bh-job-match-8ab81b71eadc.herokuapp.com/add-target/',
    title: 'Add Target',
    color: 'neutral',
    id: 'cubex-job-match-target',
    name: 'CubexJobMatchTargetWnd',
    uuid: 'cubexJobMatchTarget',
    windowName: 'CubexJobMatchTargetWnd',
  },
};